import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Box, Text } from 'Components/Base';

import { EXAM_MODE } from '../../constant';

const useInputStyles = makeStyles({
  root: (theme) => ({
    width: '100%',
    '& .MuiInputBase-input.MuiOutlinedInput-input': {
      fontFamily: theme.fonts.contentReadable,
      border: 0,
      lineHeight: 1.5,
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.colors.primary,
    },
  }),
});

const FillInTheBlank = ({
  isCorrect,
  question,
  onAnswer,
  mode,
  userAnswer,
  renderFooterBlock,
  isShowSolution,
}) => {
  const theme = useTheme();
  const classes = useInputStyles(theme);
  const answerTitle = question.fillInTheBlankItems?.[0]?.answerTitle;
  const gradeAnswer = question.fillInTheBlankItems?.[0]?.gradeAnswer ?? true;
  const handleAnswerChange = (e) => {
    onAnswer(e.target.value);
  };
  return (
    <Box>
      <Text fontFamily="contentReadable" pb={2}>
        {answerTitle}
      </Text>
      <TextField
        classes={classes}
        variant="outlined"
        placeholder="พิมพ์คำตอบของคุณได้ที่นี่"
        value={userAnswer}
        onChange={handleAnswerChange}
        disabled={(mode === EXAM_MODE.VIEW_SOLUTION && isCorrect) || isShowSolution}
        multiline={!gradeAnswer}
        rows={5} // Number of rows to display when multiline option is set to true.
      />
      {renderFooterBlock()}
    </Box>
  );
};

FillInTheBlank.propTypes = {
  isCorrect: PropTypes.bool,
  question: PropTypes.shape({
    fillInTheBlankItems: PropTypes.array,
  }),
  onAnswer: PropTypes.func,
  mode: PropTypes.oneOf(Object.values(EXAM_MODE)),
  userAnswer: PropTypes.string,
  renderFooterBlock: PropTypes.func,
  isShowSolution: PropTypes.bool,
};

FillInTheBlank.defaultProps = {
  renderFooterBlock: () => {},
};

export default FillInTheBlank;
